import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetClientRequest, sendPatchClientRequest, sendPostClientRequest } from '../../../api/helper';

export const getIndustries = createAsyncThunk('industries/getIndustries', async ({ limit, page, search, code }) => {
  let response;
  if (search) {
    response = await sendGetClientRequest(`/api/industry_categories?limit=${limit}&page=${page}&search=${search}&code=${code ? code : 1}`);
  } else {
    response = await sendGetClientRequest(`/api/industry_categories?limit=${limit}&page=${page}&code=${code ? code : 1}`);
  }
  return response.data;
});

export const industriesDetail = createAsyncThunk('industries/industriesDetail', async (parameters) => {
  const response = await sendGetClientRequest(`/api/industry_categories/${parameters.id}?limit=10000&page=1&code=${parameters.code}`);
  return response.data;
});

export const updateCategory = createAsyncThunk('industries/updateCategory', async (parameters) => {
  const response = await sendPatchClientRequest(`/api/industry_categories/`, parameters);
  return response;
});

export const addCategory = createAsyncThunk('industries/addCategory', async (parameters) => {
  const response = await sendPostClientRequest(`/api/industry_categories/${parameters?.id}`);
  return response;
});

const industriesSlice = createSlice({
  name: 'industries',
  initialState: {
    industries: [],
    lists: [],
    loading: false,
  },
  reducers: {
    updateDataIndustries: (state, action) => {
      state.lists = action.payload;
    },
  },
  extraReducers: {
    // GET INDUSTRIES
    [getIndustries.pending]: (state) => {
      state.loading = true;
    },
    [getIndustries.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.industries = payload;
        state.loading = false;
      }
    },
    [getIndustries.rejected]: (state) => {
      state.loading = false;
    },

    // GET DETAIL INDUSTRIES
    [industriesDetail.pending]: (state) => {
      state.loading = true;
    },
    [industriesDetail.fulfilled]: (state, { payload }) => {
      if (payload) {
        state.lists = payload;
        state.loading = false;
      }
    },
    [industriesDetail.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export default industriesSlice.reducer;
export const selectIndustries = (state) => state.industries;
export const { updateDataIndustries } = industriesSlice.actions;
